@if (leadScore; as score) {
  <glxy-badge [color]="leadScoreBadgeColor">
    {{ 'PROFILE_PAGE.LEAD_SCORE' | translateByObjectType: crmObjectType : { score: score } }}
  </glxy-badge>
}
